import {
    ICustomerPickupEventHandler, PackageReleaseCodeConfirmedParameters,
} from './ICustomerPickupEventHandler';
import {UpsCustomerPickupEventHandler} from "./UpsCustomerStoreEventHandler";

export class CustomerPickupEventHandler implements ICustomerPickupEventHandler {
    async packageReleaseCodeConfirmed(params: PackageReleaseCodeConfirmedParameters): Promise<void> {
        switch (params.carrierId) {
            case "ups":
                await new UpsCustomerPickupEventHandler().packageReleaseCodeConfirmed(params);
        }
    }
}